import { ToastNotification } from "carbon-components-react"
import moment from "moment-timezone"
import { useEffect, useState } from "react"

const Toast = (props) => {

    const [visible, setVisible] = useState(true)
    const caption = props.caption || moment().format('LT')
    const timeout = props.timeout || 5000
    const kind = props.kind || "info"
    const key = props.keyId

    useEffect(() => {
        const timeoutWindow = window.setTimeout(() => {
            onCloseButtonClick()
        }, timeout)

        return () => clearTimeout(timeoutWindow)
    })
    

    const onCloseButtonClick = () => {
        setVisible(false)
        props.onCloseToast && props.onCloseToast(key)
    }

    return (visible) ? (
        <ToastNotification
            caption={caption}
            key={key}
            kind={kind}
            lowContrast
            subtitle={props.subtitle}
            timeout={timeout}
            title={props.title}
            onCloseButtonClick={onCloseButtonClick}
        />
    ) : null
}

export default Toast